import gql from 'graphql-tag';

export const CUSTOM_FIELD_FIELDS = gql`
  fragment CustomFieldFields on CustomField {
    id key label type entity is_required is_active student_access sequence description values_count
    options { value label }
    options_source depends_on
  }
`;

export const GET_CUSTOM_FIELDS = gql`
  query CustomFieldDefinitions($entity: CustomFieldEntity!, $include_inactive: Boolean) {
    customFields(entity: $entity, include_inactive: $include_inactive) { ...CustomFieldFields }
  }
  ${CUSTOM_FIELD_FIELDS}
`;

export const CREATE_CUSTOM_FIELD = gql`
  mutation CreateCustomField($input: CreateCustomFieldInput!) {
    createCustomField(input: $input) { ...CustomFieldFields }
  }
  ${CUSTOM_FIELD_FIELDS}
`;

export const UPDATE_CUSTOM_FIELD = gql`
  mutation UpdateCustomField($id: ID!, $input: UpdateCustomFieldInput!) {
    updateCustomField(id: $id, input: $input) { ...CustomFieldFields }
  }
  ${CUSTOM_FIELD_FIELDS}
`;

export const DELETE_CUSTOM_FIELD = gql`
  mutation DeleteCustomField($id: ID!) {
    deleteCustomField(id: $id)
  }
`;

export const REORDER_CUSTOM_FIELDS = gql`
  mutation ReorderCustomFields($entity: CustomFieldEntity!, $ids: [ID!]!) {
    reorderCustomFields(entity: $entity, ids: $ids) { id sequence }
  }
`;

/** Ready-made field sets a school can add in one click (#574 origin templates). */
export const GET_CUSTOM_FIELD_TEMPLATES = gql`
  query CustomFieldTemplateList($entity: CustomFieldEntity!) {
    customFieldTemplates(entity: $entity) {
      key name description entity applied
      fields { key label type options_source depends_on description exists }
    }
  }
`;

export const APPLY_CUSTOM_FIELD_TEMPLATE = gql`
  mutation ApplyCustomFieldTemplate($entity: CustomFieldEntity!, $template: String!) {
    applyCustomFieldTemplate(entity: $entity, template: $template) { ...CustomFieldFields }
  }
  ${CUSTOM_FIELD_FIELDS}
`;

export const CUSTOM_FIELD_VALUE_FIELDS = gql`
  fragment CustomFieldValueFields on CustomFieldValue {
    value filled_by filled_at
    field { id key label type is_required description options { value label } options_source depends_on }
  }
`;

export const GET_STUDENT_CUSTOM_FIELD_VALUES = gql`
  query StudentCustomFieldValues($id: ID!) {
    student(id: $id) {
      id
      customFieldValues { ...CustomFieldValueFields }
    }
  }
  ${CUSTOM_FIELD_VALUE_FIELDS}
`;

export const UPDATE_STUDENT_CUSTOM_FIELD_VALUES = gql`
  mutation UpdateStudentCustomFieldValues($student_id: ID!, $values: [CustomFieldValueInput!]!) {
    updateStudentCustomFieldValues(student_id: $student_id, values: $values) { ...CustomFieldValueFields }
  }
  ${CUSTOM_FIELD_VALUE_FIELDS}
`;

export const GET_STAFF_CUSTOM_FIELD_VALUES = gql`
  query StaffCustomFieldValues($id: ID!) {
    staff(id: $id) {
      id
      customFieldValues { ...CustomFieldValueFields }
    }
  }
  ${CUSTOM_FIELD_VALUE_FIELDS}
`;

export const GET_GUARDIAN_CUSTOM_FIELD_VALUES = gql`
  query GuardianCustomFieldValues($id: ID!) {
    guardian(id: $id) {
      id
      customFieldValues { ...CustomFieldValueFields }
    }
  }
  ${CUSTOM_FIELD_VALUE_FIELDS}
`;

export const UPDATE_STAFF_CUSTOM_FIELD_VALUES = gql`
  mutation UpdateStaffCustomFieldValues($staff_id: ID!, $values: [CustomFieldValueInput!]!) {
    updateStaffCustomFieldValues(staff_id: $staff_id, values: $values) { ...CustomFieldValueFields }
  }
  ${CUSTOM_FIELD_VALUE_FIELDS}
`;

export const UPDATE_GUARDIAN_CUSTOM_FIELD_VALUES = gql`
  mutation UpdateGuardianCustomFieldValues($guardian_id: ID!, $values: [CustomFieldValueInput!]!) {
    updateGuardianCustomFieldValues(guardian_id: $guardian_id, values: $values) { ...CustomFieldValueFields }
  }
  ${CUSTOM_FIELD_VALUE_FIELDS}
`;
